import { render, staticRenderFns } from "./CtrlJigyoshoGinko.vue?vue&type=template&id=54baf963&scoped=true&"
import script from "./CtrlJigyoshoGinko.vue?vue&type=script&lang=ts&"
export * from "./CtrlJigyoshoGinko.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlJigyoshoGinko.vue?vue&type=style&index=0&id=54baf963&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baf963",
  null
  
)

export default component.exports